import type { ReactNode } from "react";
import InfoButton, { type InfoContent } from "./InfoButton";
import AiBadge from "./AiBadge";

interface Props {
  eyebrow?: ReactNode;
  title: ReactNode;
  meta?: ReactNode;          // segments, legend, baseline picker etc.
  info?: InfoContent;        // optional explainer tooltip — renders next to meta
  foot?: ReactNode;
  span2?: boolean;
  /** Renders an "AI/ML" badge inline with the title — for surfaces that depend on a model. */
  ai?: boolean;
  children: ReactNode;
}

// Mirrors the sample-v2 .card / .card-head / .card-body / .card-foot structure.
export default function Card({ eyebrow, title, meta, info, foot, span2, ai, children }: Props) {
  const hasMeta = meta != null || info != null;
  return (
    <div className={`card${span2 ? " span-2" : ""}`}>
      <div className="card-head">
        <div>
          {eyebrow && <div className="card-eyebrow">{eyebrow}</div>}
          <h3 className="card-title">
            {title}
            {ai && <AiBadge />}
          </h3>
        </div>
        {hasMeta && (
          <div className="card-meta">
            {meta}
            {info && <InfoButton info={info} />}
          </div>
        )}
      </div>
      <div className="card-body">{children}</div>
      {foot && <div className="card-foot tight">{foot}</div>}
    </div>
  );
}
